import ApiService from 'common/service/api';
import { PublicError } from 'common/service/error';
import { catchError, map } from 'rxjs/operators';

export default class JobService extends ApiService {
  constructor(config) {
    super(config);

    this.baseURL = `${this.baseURL}/jobs`;
  }

  getAll(params) {
    return this.fetchCollection('', params);
  }

  getById(jobId) {
    return this.fetchResource(`/${jobId}`);
  }
  
  cancelJob(jobId) {
    return this.fetchResource(`/${jobId}`, {
      method: 'POST',
      body: JSON.stringify({ "instruction": "cancel"}),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .pipe(
        catchError((err) => {
          if (err.status === 400 && err.response) {
            throw new PublicError(err.response.message);
          }

          throw err;
        }),
      );
  }
  create(job) {
    return this
      .post('', job)
      .pipe(
        map(ApiService.resourceJson),
        catchError((err) => {
          if (err.status === 400 && err.response) {
            throw new PublicError(err.response.message);
          }

          throw err;
        }),
      );
  }

  save(job) {
    return this
      .put(`/${job.id}`, job)
      .pipe(
        map(ApiService.resourceJson),
        catchError((err) => {
          if (err.status === 400 && err.response) {
            throw new PublicError(err.response.message);
          }

          throw err;
        }),
      );
  }
}



